import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import HeaderDetails from '../shared-components/HeaderDetails'
import Spinner from '../ui-elements/Spinner'
import Card from '../ui-elements/Card'
import YellowAlert from '../ui-elements/YellowAlert'
import ProcessInstanceChooser from './ProcessInstanceChooser'
import { startProcessInstance } from './startProcessInstance'



type Props = {
}

function ProcessList({
}: Props) {


    const {
        sendMessageToWebsocket,
        setShowModal,
        processData,
        t
    } = useContext(GlobalContext)

    const navigate = useNavigate()




    const [hasFetchedData, setHasFetchedData] = useState(false)


    useEffect(() => {
        if (!hasFetchedData) {
            fetchData()
        }
    }, [hasFetchedData])

    const fetchData = () => {
        console.log('fetching data')
        let requestAssets = JSON.stringify({
            action: "processesClient",
            subAction: "fetchProcesses",
        })
        sendMessageToWebsocket(requestAssets)
    }

    const startProcess = (processDefinitionId: string) => {
        startProcessInstance({
            processId: processDefinitionId,
            sendMessageToWebsocket,
            setShowModal,
            navigate,
            loadingText: t('ProcessPages.ProcessSummary.startingProcess'),
        })
    }




    return <div className={`w-full flex-1 h-full flex flex-col items-center gap-2`}>

        <HeaderDetails
            titleText={t(`ProcessPages.ProcessList.heading`)}
        />

        <div className={`max-w-3xl w-full px-5 py-5 flex flex-col gap-4`}>


            {processData && <div className={`flex flex-col gap-2`}>{Object.keys(processData).map((processDefinitionId: string, index: number) => {
                const processDefinition = processData[processDefinitionId]
                const runningRecordIds = Object.keys(processDefinition.processRecords || {})
                const canStartNewInstance = runningRecordIds.length === 0 || processDefinition.AllowMultipleInstances === true
                const startButtonText = processDefinition.StartButtonLabel || t('ProcessPages.ProcessSummary.startProcess')

                return <Card key={index}>
                    <div className={`w-full flex flex-col gap-3 items-start`}>

                        <h4 className={`text-lg font-righteous text-brandblue`}>{processDefinition.DisplayName}</h4>

                        {runningRecordIds.length === 1 && (() => {
                            const onlyRunningRecordId = runningRecordIds[0]
                            const processRecord = processDefinition.processRecords[onlyRunningRecordId].processRecord
                            const currentStageId = processRecord && processRecord.CurrentStageId
                            const currentStageName = currentStageId && processDefinition.Stages && processDefinition.Stages[currentStageId] && processDefinition.Stages[currentStageId].DisplayName
                            return <div className={`w-full flex flex-col gap-2 items-start`}>
                                {currentStageName && <YellowAlert fullwidth={true} alignment={`left`}>⏰ {t(`ProcessPages.ProcessList.currentlyInStage`, { stage: currentStageName })}</YellowAlert>}
                                <Button
                                    text={t(`Buttons.view`)}
                                    internalLinkUrl={`/process/${processDefinitionId}/record/${onlyRunningRecordId}`}
                                    fullwidth={true}
                                    variant='primary'
                                />
                            </div>
                        })()}

                        {runningRecordIds.length > 1 && <ProcessInstanceChooser processId={processDefinitionId} />}

                        {canStartNewInstance && <Button
                            onClick={() => startProcess(processDefinitionId)}
                            text={startButtonText}
                            fullwidth={true}
                            variant='primary'
                        />}

                    </div>
                </Card>
            })}</div>}

            {!processData && <Spinner size='large'>{t(`General.loading`)}</Spinner>}
        </div>
    </div>

}
export default ProcessList
